
import { computed, defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'IconBase',
  props: {
    width: {
      type: Number as PropType<number>,
      required: true,
    },
    height: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const viewBox = computed(() => `0 0 ${props.width} ${props.height}`)
    const style = computed(() => ({ width: `${props.width / props.height}em` }))
    return {
      viewBox,
      style,
    }
  },
})
